import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MaintenanceModeService } from '@app/shared/services/maintenance-mode.service';

@Component({
  selector: 'a360-maintenance-mode',
  templateUrl: './maintenance-mode.component.html',
  styleUrls: ['./maintenance-mode.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MaintenanceModeComponent {
  public get retryAfter() {
    return this.maintenanceModeService.retryAfter;
  }

  constructor(private readonly maintenanceModeService: MaintenanceModeService) {}
}
